import { useState } from "react";

import Box from "@/components/Box";
import Grid from "@/components/Grid";
import RichText from "@/components/RichText";
import { useOrganisationBasketContext } from "@/contexts/organisations/OrganisationBasketContext";
import ChevronComponent from "@/tpo/Chevron";
import { GilroyFontCurrency } from "@/tpo/Currency";
import Group from "@/tpo/Group";
import { Error } from "@/tpo/InputWrapper";
import Stack from "@/tpo/Stack";
import ButtonV2 from "@/v2/Buttons";

export default function AddOnDetail({
  description,
  expandedContent,
  name,
  state,
  onRemove,
  onAdd,
  price,
  rrpPrice,
  text,
  error,
  readOnly = false
}) {
  const { loading, basket } = useOrganisationBasketContext();

  const [show, setShow] = useState(false);

  let bg = "white";
  let button = readOnly ? null : (
    <ButtonV2 color="green" onClick={onAdd} disabled={loading} type="button" size="sm">
      {text || "add"}
    </ButtonV2>
  );
  if (!readOnly && state === "unavailable") {
    bg = "#E5E5E5";
    button = (
      <ButtonV2
        color="midGrey"
        disabled
        sx={{
          opacity: 1
        }}
        type="button"
        size="sm"
      >
        {text || "add"}
      </ButtonV2>
    );
  } else if (!readOnly && state === "selected") {
    button = (
      <ButtonV2
        color="red"
        style={{
          lineHeight: "70%"
        }}
        onClick={onRemove}
        disabled={loading}
        type="button"
        size="sm"
      >
        remove
      </ButtonV2>
    );
  }

  const showActions = Boolean(button);

  return (
    <Grid
      p={4}
      gridTemplateColumns={readOnly ? "1fr" : ["1fr", "1fr 1fr"]}
      gridRowGap={20}
      bg={bg}
      data-component-name="Addon"
      borderRadius={20}
    >
      <Box
        fontFamily="gilroyBold"
        fontSize={[16, 16, 18]}
        alignSelf="flex-start"
        data-testid="addOn:name"
      >
        {name}
      </Box>
      {readOnly ? null : (
        <Stack gap={20} alignItems={["flex-start", "flex-end"]} width={["100%", "auto"]}>
          <Group
            alignItems="center"
            gap={20}
            width={["100%", "auto"]}
            justifyContent={["space-between", "flex-start"]}
          >
            <Stack gap={10} alignItems={["flex-start", "flex-end"]}>
              <GilroyFontCurrency
                value={price}
                color="dark"
                symbol={basket?.currencySymbol}
                fontSize={24}
              />
              {rrpPrice != null && (
                <GilroyFontCurrency
                  value={rrpPrice}
                  symbol={basket?.currencySymbol}
                  fontSize={14}
                  decimalFontSize={14}
                  prefix="RRP"
                  color="midGrey"
                />
              )}
            </Stack>
            {showActions ? button : null}
          </Group>
        </Stack>
      )}
      {error ? (
        <Box gridColumnStart={1} gridColumnEnd={readOnly ? 2 : ["2", "3"]}>
          <Error error={error} fontSize={[14, 14, 16]} />
        </Box>
      ) : null}
      <Box
        gridColumnStart={readOnly ? 1 : ["1", "2"]}
        gridColumnEnd={readOnly ? 2 : ["2", "3"]}
        justifySelf="end"
      >
        <ButtonV2
          variant="transparent"
          rightIcon={<ChevronComponent direction={show ? "top" : "bottom"} fill="black" />}
          onClick={() => setShow(!show)}
          p={0}
          size={null}
          ml="auto"
          sx={{
            fontFamily: "gilroyBold",
            fontSize: 10
          }}
          type="button"
        >
          details
        </ButtonV2>
      </Box>
      {show && (
        <Box gridColumn="1 / -1">
          {expandedContent ? (
            expandedContent
          ) : (
            <RichText
              fontFamily="gilroyMedium"
              fontSize={[16, 16, 18]}
              py={[15, 15, 30]}
              style={{
                whiteSpace: "normal"
              }}
            >
              {description}
            </RichText>
          )}
        </Box>
      )}
    </Grid>
  );
}
